<footer class="app-footer py-3 px-2">
  <div class="container-fluid">
    <div class="row align-items-center gy-2">

      <!-- Left -->
      <div class="col-md-6 text-center text-md-start">
        <span class="footer-text">
          © {{ currentYear }} <strong>Eventz</strong>. All rights reserved.
        </span>
      </div>

      <!-- Right -->
      <div class="col-md-6 text-center text-md-end">
        <span>Designed & Developed By </span><a href="https://varnik.cloud" target="_blank" class="footer-link text-decoration-none">VarNik.Cloud</a>
      </div>

    </div>
  </div>
</footer>

